import service from './request.js';
import BASE_URL from './api.js';

// 题库分类
export function getCategoryExam() {
    // /api/v2/course/categoryP/0
    return service.get(`${BASE_URL}/course/categoryP/0`)
}

// 题目列表
// /paper?type=1&cate_id=26&per_page=10&page=1
export function getPaperList(params) {
    return service.get(`${BASE_URL}/paper?type=${params.type}&cate_id=${params.cate_id}&per_page=1000&page=1`)
}
// 试卷详情
export function getPaperDetail(params) {
    return service.get(`${BASE_URL}/paper/${params.id}?page=${params.page}&per_page=${params.per_page}`)
}
//  试卷/练习的空白答题卡 初始化新试卷答题卡
export function getSheetEmpty(id) {
    return service.get(`${BASE_URL}/paper/sheet/${id}`)
}
// 试卷提交 
export function postSubmitExam(id,submitData) {
    return service.post(`${BASE_URL}/paper/submit/${id}`,submitData)
}
// 答题报告 
export function getExamResult(id) {
    return service.get(`${BASE_URL}/paper/result/${id}`)
}
// 试卷解析 解析类型, 1只看错题解析,0看全部解析 
export function getExamAnalysis(params) { 
    return service.get(`${BASE_URL}/paper/analysis/${params.id}?is_error=${params.is_error}&page=1&per_page=400`)
}
// 做题记录
export function getExamRecord (params) { 
    return service.get(`${BASE_URL}/paper/answer?page=${params.page}&per_page=${params.per_page}`)
}

// 未完成试卷详情  /paper/754?page=1&per_page=100&exam_id=3886
export function getPaperIncomplete (params) {
    return service.get(`${BASE_URL}/paper/${params.id}?page=${params.page}&per_page=${params.per_page}&exam_id=${params.exam_id}`)
}
//  未完成试卷/练习的空白答题卡 初始化新试卷答题卡 /paper/sheet/62?exam_id=409
export function getSheetIncomplete(params) {
    return service.get(`${BASE_URL}/paper/sheet/${params.id}?exam_id=${params.exam_id}`)
}

// 章节练习分类
// /pchapter?cate_id=26
export function getChapterCategory(id) {
    return service.get(`${BASE_URL}/pchapter?cate_id=${id}`)
}
// 章节列表 /pchapter/3
export function getChapterList(id) {
    return service.get(`${BASE_URL}/pchapter/${id}`)
}
// 章节练习试卷 /pchapter/list?cate_id=26
export function getChapterExam(id) {
    return service.get(`${BASE_URL}/pchapter/list?cate_id=${id}`)
}

// 收藏 
export function getCollectList() {
    return service.get(`${BASE_URL}/paper/collect/list?per_page=10&page=1`)
}
// 收藏题目
export function getCollectExam(id) {
    return service.get(`${BASE_URL}/paper/collect/${id}`)
}
// 错题列表
export function getWrongList(params) {
    return service.get(`${BASE_URL}/paper/wrong/list?per_page=${params.per_page}0&page=${params.page}`)
}
// 错题试题
export function getwrongExam(params) {
    return service.get(`${BASE_URL}/paper/wrong/${params.id}?per_page=${params.per_page}&page=${params.page}`)
}
// 单个题目提交答案
export function postSubmitTest(id,submitData) {
    return service.post(`${BASE_URL}/paper/solution/${id}`,submitData)
}
// 单个题目的解析
// export function getSingleAnalysis(params) {
//     return service.get(`${BASE_URL}/paper/question/${params.id}?ueq_id=${params.ueq_id}`)
// }
